import React, { useState } from "react";
import "./Homepage.scss";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import AA from "../../Images/AA.png";
import BB from "../../Images/BB.png";
import CC from "../../Images/CC.png";
import DD from "../../Images/DD.png";
import EE from "../../Images/EE.png";
import FF from "../../Images/FF.png";
import GG from "../../Images/GG.png";
import LL from "../../Images/LL.webp";
import HH from "../../Images/HH.png";
import II from "../../Images/II.jpg";
import JJ from "../../Images/JJ.png";
import KK from "../../Images/KK.webp";
import Icon1 from "../../Images/Icon1.png";
import Icon3 from "../../Images/Icon3.png";
import { Link } from "react-router-dom";

export default function First() {
  const [icon, setIcon] = useState(Icon1);
  let items = ["", "", "", "", ""];
  console.log(items.length);
  const [showPopUp, setShowPopUp] = useState(false);

  const handleButtonClick = () => {
    setShowPopUp(true);
  };

  const handleClose = () => {
    setShowPopUp(false);
  };

  const slideImages = [
    [
      {
        url: AA,
        caption: "HTML",
      },
      {
        url: BB,
        caption: "CSS",
      },
      {
        url: CC,
        caption: "JavaScript",
      },
      {
        url: DD,
        caption: "ReactJS",
      },
    ],
    [
      {
        url: EE,
        caption: "TypeScript",
      },
      {
        url: FF,
        caption: "jQuery",
      },
      {
        url: GG,
        caption: "Bootstrap",
      },
      {
        url: LL,
        caption: "CSS Processors",
      },
    ],
    [
      {
        url: HH,
        caption: "NodeJS",
      },
      {
        url: II,
        caption: "ExpressJS",
      },
      {
        url: JJ,
        caption: "MongoDB",
      },
      {
        url: KK,
        caption: "SQL",
      },
    ],
  ];
  return (
    <div className="flexbox-introd">
      <div className="flexbox-intro">
        <div className="intro">
          <div
            style={{
              fontSize: "20px",
              background: "linear-gradient( #eeff0080,rgba(255, 0, 0, 0.5))",
              width: "300px",
              border: "2px solid purple",
            }}
          >
            Welcome to my personal website
          </div>
          <div
            className="imhabib"
          >
            Hi! I'm Abib, Full Stack Developer
          </div>
          <div
            className="bio1"
          >
            I have a passion for creating intuitive and engaging websites that
            deliver a seamless user experience. Whether it's crafting user
            interfaces that are visually appealing and responsive or developing
            interactive features that delight users, I'm committed to staying
            up-to-date with the latest trends and technologies in the industry
            to ensure that my clients receive the best possible solutions.
            <div ><Link style={{ textDecoration: "none" }} to="/bio">
        <button className="Questions">Get Started</button>
      </Link></div>
          </div>
        </div>
        <div className="introImg">
          <img
            src={icon}
            style={{
              borderRadius: "50%",
              height: "300px",
              width: "250px",
              margin: "auto",
            }}
            alt=""
          />
          {showPopUp && (
            <div className="popup">
              <div className="popup-content">
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
                <p>
                  Even my hair can be a customizable web component :)
                </p>
              </div>
            </div>
          )}
          <div className="colors">
            <button
              className="color1"
              onClick={() => {
                setIcon(Icon1);
                handleClose();
              }}
            ></button>
            <button
              className="color3"
              onClick={() => {
                setIcon(Icon3);
                handleButtonClick();
              }}
            ></button>
          </div>
        </div>
      </div>
      <div
            className="bio2"
          >
            I have a passion for creating intuitive and engaging websites that
            deliver a seamless user experience. Whether it's crafting user
            interfaces that are visually appealing and responsive or developing
            interactive features that delight users, I'm committed to staying
            up-to-date with the latest trends and technologies in the industry
            to ensure that my clients receive the best possible solutions.
          </div>
          

      
    </div>
  );
}
